import { combineReducers } from "@reduxjs/toolkit";
import featuresLogReducer, {
  clearFeatureLogState,
  setFeatureLogStartMonth,
  setFeatureLogCompany,
  setFeatureLogLocation,
  setFeatureLogEndMonth
} from "./features-log-slice";
import companiesLogReducer, {
  clearCompanyLogState,
  setCompanyLogStartMonth,
  setCompanyLogEndMonth,
  setCompanyLogLocation,
  setCompanyLogLastYear
} from "./companies-log-slice";
import downloadsLogReducer, {
  clearDownloadLogState,
  setDownloadLogFromDate,
  setDownloadLogToDate,
  setDownloadLogLocation
} from "./dowloads-log-slice";

const logReducer = combineReducers({
  featuresLog: featuresLogReducer,
  companiesLog: companiesLogReducer,
  downloadsLog: downloadsLogReducer
});

export {
  clearFeatureLogState,
  setFeatureLogStartMonth,
  setFeatureLogEndMonth,
  setFeatureLogCompany,
  setFeatureLogLocation,
  clearCompanyLogState,
  setCompanyLogStartMonth,
  setCompanyLogEndMonth,
  setCompanyLogLocation,
  clearDownloadLogState,
  setDownloadLogFromDate,
  setDownloadLogToDate,
  setDownloadLogLocation,
  setCompanyLogLastYear
};

export default logReducer;
